import React, { useState } from "react";
import './staff-modules.css';
const SAMPLE_BATCHES = ["GNM 1st Year", "GNM 2nd Year", "GNM 3rd Year"];
const SAMPLE_SUBJECTS = ["Nursing Foundations", "Community Health", "Medical-Surgical Nursing"];
const SAMPLE_STUDENTS = [
  { id: 1, name: "Anjali Sharma" },
  { id: 2, name: "Rahul Gupta" },
  { id: 3, name: "Sneha Reddy" }
];

export default function Assessment() {
  const [batch, setBatch] = useState(SAMPLE_BATCHES[0]);
  const [subject, setSubject] = useState(SAMPLE_SUBJECTS[0]);
  const [records, setRecords] = useState(
    SAMPLE_STUDENTS.map((s) => ({ ...s, theory: "", practical: "" }))
  );
  const [message, setMessage] = useState("");
  const [showReport, setShowReport] = useState(false);

  const handleMarksChange = (id, field, value) => {
    setRecords((prev) =>
      prev.map((s) =>
        s.id === id ? { ...s, [field]: value } : s
      )
    );
    setMessage("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage("Assessment marks saved successfully!");
    setShowReport(true);
  };

  return (
    <div className="module-wrapper">
      <h2>Assessment</h2>
      <p>
        Enter and review internal assessment marks for students by subject and batch. Generate progress charts and download mark sheets for documentation.
      </p>
      <form className="assessment-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <label>Batch:</label>
          <select value={batch} onChange={(e) => setBatch(e.target.value)}>
            {SAMPLE_BATCHES.map((b) => (
              <option key={b}>{b}</option>
            ))}
          </select>
          <label>Subject:</label>
          <select value={subject} onChange={(e) => setSubject(e.target.value)}>
            {SAMPLE_SUBJECTS.map((s) => (
              <option key={s}>{s}</option>
            ))}
          </select>
        </div>
        <table className="assessment-table">
          <thead>
            <tr>
              <th>Student Name</th>
              <th>Theory Marks</th>
              <th>Practical Marks</th>
            </tr>
          </thead>
          <tbody>
            {records.map((student) => (
              <tr key={student.id}>
                <td>{student.name}</td>
                <td>
                  <input
                    type="number"
                    min={0}
                    max={100}
                    value={student.theory}
                    onChange={(e) => handleMarksChange(student.id, "theory", e.target.value)}
                    placeholder="Theory"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    min={0}
                    max={100}
                    value={student.practical}
                    onChange={(e) => handleMarksChange(student.id, "practical", e.target.value)}
                    placeholder="Practical"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className="primary-action" type="submit">Save Assessment</button>
      </form>
      {message && <div className="form-success">{message}</div>}
      {showReport && (
        <div className="assessment-report">
          <h3>Assessment Report: {subject} ({batch})</h3>
          <table className="assessment-report-table">
            <thead>
              <tr>
                <th>Student</th>
                <th>Theory</th>
                <th>Practical</th>
                <th>Total</th>
                <th>Average</th>
              </tr>
            </thead>
            <tbody>
              {records.map((s) => {
                const theory = Number(s.theory) || 0;
                const practical = Number(s.practical) || 0;
                const total = theory + practical;
                const avg = total / 2;
                return (
                  <tr key={s.id}>
                    <td>{s.name}</td>
                    <td>{theory}</td>
                    <td>{practical}</td>
                    <td>{total}</td>
                    <td>{avg.toFixed(1)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <button
            className="secondary-action"
            style={{ marginTop: 12 }}
            onClick={() => window.print()}
          >
            Download/Print Marksheet
          </button>
        </div>
      )}
    </div>
  );
}